import React from "react";
import "./languageToggle.css";

const LanguageToggle = ({ isVisible, toggleVisibility }) => {
  return (
    <center>
      <div className="switch">
        <input
          id="language-toggle"
          className="check-toggle check-toggle-round-flat"
          type="checkbox"
          checked={isVisible}
          onChange={toggleVisibility}
        />
        <label htmlFor="language-toggle"></label>
        <span className="on">NE</span>
        <span className="off">EN</span>
      </div>
    </center>
  );
};

export default LanguageToggle;
